import { NgModule }              from '@angular/core';
import { SharedModule }          from '../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { LoginComponent }         from './login.component';
import { routing }               from './login.route';
import { HttpClientService } from '../../shared/http-client-service';
import {LoginService} from './services/login.service';
import { DialogModule } from 'primeng/dialog';
import { ConfigService } from '../../config/config.service';
import{BlockUIService} from"../../shared/services/blockui.service";
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { FormsModule } from '@angular/forms';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha-2';
// Routed Feature module
@NgModule({
  imports:      [CommonModule, FormsModule, SharedModule,DialogModule,ButtonModule, routing , ProgressSpinnerModule, RecaptchaModule, RecaptchaFormsModule
                ],
  declarations: [ LoginComponent ],
  providers: [LoginService, HttpClientService,ConfigService,BlockUIService]
})

export class LoginModule { }
